import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.rules.set.mutation.gql"
import type {
  FeatureGroupRulesSetMutation,
  FeatureGroupRulesSetMutationVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.rules.set.mutation"

type Options = MutationHookOptions<
  FeatureGroupRulesSetMutation,
  FeatureGroupRulesSetMutationVariables
>

export function useFeatureGroupRulesSetMutation(options?: Options) {
  return useMutation<
    FeatureGroupRulesSetMutation,
    FeatureGroupRulesSetMutationVariables
  >(mutation, options)
}
